<i18n>
    {
    "en": {},
    "ru": {
    "link": "Группы ароматов",
    "read_more": "Подробнее"
    }
    }
</i18n>
<template>
    <div :class="rootClasses" class="block-group">
        <div class="block-group__picture-wrapper">
            <img class="block-group__picture"
                :class="pictureClasses"
                v-lazy-load :data-src="getPicture"
                :alt="name" />
        </div>
        <div class="block-group__content">
            <div
                class="block-group__content-header"
                :class="headerClasses">
                <h6 class="block-group__name">{{ name }}</h6>
                <div class="block-group__count" v-if="count || count === 0">{{ count | numberFormat }}</div>
            </div>
            
            <template v-if="hideTextForSeo">
                <client-only>
                    <!-- eslint-disable-next-line -->
                    <div v-html="htmlDescription" v-if="htmlDescription" class="block-group__description"></div>
                    <div v-else class="block-group__description">{{ description }}</div>
                </client-only>
            </template>
            <template v-else>
                <!-- eslint-disable-next-line -->
                <div v-html="htmlDescription" v-if="htmlDescription" class="block-group__description"></div>
                <div v-else class="block-group__description">{{ description }}</div>
            </template>

            <div class="block-group__link-wrapper">
                <html-link v-if="url"
                    :url="url"
                    class="block-group__link">
                    {{ $t('read_more') }}
                </html-link>
                <html-link v-else-if="routeTo"
                    :to="routeTo"
                    class="block-group__link">
                    {{ $t('read_more') }}
                </html-link>
                <a v-else-if="link"
                    rel="nofollow"
                    target="_blank"
                    :href="link"
                    class="block-group__link">
                    {{ $t('read_more') }}
                </a>
                <svg-icon class="block-group__icon" name="chevron-right" />
            </div>
        </div>
    </div>
</template>
<script>
import offerMixin from '@/mixins/catalog/offers.mixin'
export default {
    name: 'BlockGroup',
    mixins: [offerMixin],
    props: {
        pictureCircle: {
            type: Boolean,
            default: false
        },
        autoheight: {
            type: Boolean,
            default: false
        },
        border: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'normal'
        },
        pictureCovered: {
            type: Boolean,
            default: false
        },
        hideTextForSeo: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        rootClasses() {
            return {
                'block-group_auto-height': this.autoheight,
                'block-group_border': this.border,
                'block-group_large': this.size === 'large',
            }
        },
        headerClasses() {
            return {
                'block-group__content-header_column': this.border
            }
        },
        pictureClasses() {
            return {
                'block-group__picture_circle': this.pictureCircle,
                'block-group__picture_covered': this.pictureCovered,
            }
        }
    }
};

</script>
<style lang="less">
.block-group {
    --block-group-height: rem(172);

    display: flex;

    padding-top: rem(22);

    height: var(--block-group-height);

    position: relative;

    overflow: hidden;

    .page-padding();

    @{desktop} & {
        --block-group-height: rem(160);

        cursor: pointer;

        .page-padding();

        .animate(box-shadow);

        .hover({
            box-shadow: @menu-desktop-box-shadow;
        })
    }

    &__content {
        margin-top: rem(5);
        margin-left: rem(20);

        width: calc(100% - rem(56));

        &:after {
            content: "";
            display: table;
            clear: both;
        }

        @{desktop} & {
            margin-top: 0;
            margin-left: 0;
            padding-left: rem(20);

            width: calc(100% - rem(56));
            max-width: 100%;
        }
    }

    &__name {
        font-weight: 500;
        text-overflow: ellipsis;
        white-space: nowrap;

        margin-bottom: rem(2);

        max-width: rem(155);

        overflow: hidden;

        @media @min375 {
            max-width: rem(200);
        }

        @media @min550 {
            max-width: 100%;
        }
    }

    &__description {
        margin-top: rem(5);

        max-height: rem(70);

        .text-ellipsis(3);

        .photo-gallery {
            display: none;
        }

        p {
            text-align: left !important;
        }

        &:after {
            content: "";
            display: table;
            clear: both;
        }

        @{desktop} & {
            font-size: rem(13);
            line-height: 1.6;

            height: rem(61);
        }
    }

    &__content-header {
        display: flex;
        justify-content: space-between;

        &_column {
            @{desktop} & {
                flex-flow: column-reverse nowrap;

                .block-group__count {
                    margin-bottom: rem(15);
                }
            }
        }
    }

    &__count {
        color: @color-primary;
        font-size: rem(13);

        transform: translateY(rem(1));
    }

    &__icon {
        height: rem(15);
        width: rem(18);

        @{desktop} & {
            margin-left: rem(2);
        }
    }

    &__link {
        color: @color-primary;

        @{desktop} & {
            .hover({
                text-decoration: underline;
            });

            font-size: rem(14);

            &:hover,
            &:focus {
                .block-group__icon {
                    transform: translateX(rem(4));
                }
            }
        }

        &:after {
            content: '';
            display: block;

            position: absolute;
            top: rem(5);
            right: rem(5);
            bottom: rem(5);
            left: rem(5);
        }

        &-wrapper {
            display: flex;
            align-items: center;

            color: @color-primary;

            margin-top: rem(8);

            width: 100%;

            @{desktop} & {
                margin-top: rem(12);
            }
        }
    }

    &__picture {
        object-fit: cover;
        .center-image(56);

        width: rem(56);

        &_circle {
            border-radius: 50%;
        }

        &_covered {
            object-fit: cover;
        }

        &-wrapper {
            flex-shrink: 0;

            width: rem(56);
        }
    }

    &_auto-height {
        padding-bottom: 23px;

        height: auto;

        .block-group__description {
            display: table;

            overflow: visible;
        }

        &:after {
            content: "";
            display: table;
            clear: both;
        }
    }

    &_border {
        border: 1px solid @color-gray-white;
        border-radius: rem(3);
    }

    &_large {
        @{desktop} & {
            height: rem(196);
        }
    }
}

</style>
